// extracted by mini-css-extract-plugin
export default {"App":"App_App__Pzkhc","searchSummary":"App_searchSummary__NNnp9"};